import * as Sentry from '@sentry/react';

/**
 * Records a non-fatal error that was caught and handled, so it surfaces in Sentry
 * and the dev console instead of being silently swallowed. Use only for errors worth
 * investigating — not for expected control-flow fallbacks (those would just flood Sentry).
 *
 * @param context - Short identifier for where the error was caught (e.g. "useChat.streamFallback").
 * @param error - The caught value.
 */
export function reportError(context: string, error: unknown): void {
  console.error(`[${context}]`, error);
  Sentry.captureException(error, { extra: { context } });
}
